<px-t10-news-tile-list
    (selectedFilters)="onFilterChanged($event)"
    [filterGroups]="filterGroups"
    [newsteaserTiles]="tiles"
    [hasMore]="totalNewsCount > news?.length"
    [isBlog]="_blog"
    (loadMore)="loadMore()"
    [contactFooter]="_contactFooter"
></px-t10-news-tile-list>
